var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-subheader",class:{
    'primary-text-color': _vm.primary,
    'secondary-text-color': _vm.secondary,
  },on:{"click":e => _vm.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }